import clsx from "clsx";
import dynamic from "next/dynamic";
import Image from "next/image";
import { ReactNode } from "react";

import { UserInfoMobile } from "@/features/banner/UserInfoMobile";
import { Container } from "@/features/common/components/layout/Container";
import { isMdDown, useBreakpoint } from "@/features/common/hooks/useBreakpoint";
import { useUserContext } from "@/features/user/contexts/useUserContext";
import {
  ChannelFragment,
  UserBasicInfoFragment,
  UserFollowCountFragment,
} from "@/generated/generated-hooks";

const ProfileEditButtonMobile = dynamic(
  () =>
    import("./ProfileEditButtonMobile").then(
      (mod) => mod.ProfileEditButtonMobile,
    ),
  { ssr: false },
);
const BannerInfo = dynamic(
  () => import("./BannerInfo").then((mod) => mod.BannerInfo),
  { ssr: false },
);
const BannerInfoMobile = dynamic(
  () => import("./BannerInfoMobile").then((mod) => mod.BannerInfoMobile),
  { ssr: false },
);

type PublicProfileBannerProps = {
  imgUrl: string;
  actionComponent?: ReactNode;
  avatar?: ReactNode;
  writer: UserBasicInfoFragment & UserFollowCountFragment;
  channel?: ChannelFragment;
};
export const PublicProfileBanner: React.FC<PublicProfileBannerProps> = (
  props,
) => {
  const breakpoint = useBreakpoint();
  const mdDown = isMdDown(breakpoint);

  const { imgUrl, actionComponent, avatar, writer, channel } = props;
  const { _id, displayName } = writer;

  const { user, ready, ssrUserId } = useUserContext();
  const isOwner = (!ready && ssrUserId === _id) || (ready && user?._id === _id);
  return (
    <>
      <div
        className={clsx(
          "relative flex flex-col w-full h-200 md:h-400 banner-mb-mobile md:banner-mb-desktop",
          !!actionComponent && "cursor-pointer",
        )}
      >
        <Image
          priority
          src={imgUrl}
          alt={`${displayName}'s banner`}
          layout="fill"
          objectFit="cover"
          objectPosition="center"
        />

        {isOwner && mdDown && <ProfileEditButtonMobile />}

        <div className="relative flex flex-col mt-auto justify-end overlay-bg banner-overlay-h-mobile md:banner-overlay-h-desktop">
          <div className="flex h-full">
            <Container>
              <div className="flex h-full">
                <div className="flex">{avatar}</div>
                {mdDown ? (
                  <BannerInfoMobile writer={writer} />
                ) : (
                  <BannerInfo writer={writer} channel={channel} />
                )}
              </div>
            </Container>
          </div>
        </div>
      </div>

      <div className="md:hidden">
        <UserInfoMobile writer={writer} isOwner={isOwner} />
      </div>
    </>
  );
};
